import { requestWithoutToken, requestWithToken } from "../utils/apis";

export const fetchProjectList = async (page, limit, search = "") => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/project/list?page=${page}&limit=${limit}&search=${search}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const fetchProjectDetail = async (id,page, limit, search = "") => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/project/details/${id}?page=${page}&limit=${limit}&search=${search}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const CreateNewProject = async (payload) => {
  try {
    const res = await requestWithToken(
      "POST",
      "/api/project",
      payload
    );
    return res;
  } catch (error) {
    return error?.response?.data;
  }
};
export const UpdateProject = async (id, payload) => {
    try {
        const response = await requestWithToken(
            "PUT",
            `/api/project/${id}`,
            payload
        );

        return response.data;
    } catch (err) {
        return err?.response?.data || {
            status: 0,
            message: "Failed to update organization",
        };
    }
};
export const deleteProject = async (id) => {
    try {
      const response = await requestWithToken("DELETE", `/api/project/${id}`);
        return response.data;
    } catch (err) {
        return err.response.data;
    }
};